module.exports = __webpack_public_path__ + "static/media/indoor-secondary.39daca7c.jpg";